export default __webpack_public_path__ + "static/media/Increase-Productivity.6a567e4a.png";